export interface IncidentSummary {
  id: string;
  status: 'active' | 'ended';
  startedAt: string;
  endedAt: string | null;
}

export async function fetchIncidentsByAnnouncementId(
  locationId: string,
  startDate: Date,
  endDate: Date,
): Promise<Map<string, IncidentSummary>> {
  try {
    /* eslint-disable ember/use-ember-get-and-set */
    const url = new URL('/a/communication/api/v1/incidents', window.location.origin);
    url.searchParams.set('filter[location]', locationId);
    url.searchParams.set('filter[datetime_from]', startDate.toISOString());
    url.searchParams.set('filter[datetime_to]', endDate.toISOString());
    url.searchParams.set('filter[archived]', 'null');
    url.searchParams.set('page[size]', '100');
    /* eslint-enable ember/use-ember-get-and-set */

    const response = await fetch(url.toString(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/vnd.api+json' },
    });
    if (!response.ok) return new Map();

    const json = (await response.json()) as {
      data: {
        id: string;
        attributes: { status: 'active' | 'ended'; started_at: string; ended_at: string | null };
        relationships: { announcements: { data: { id: string }[] } };
      }[];
    };

    const map = new Map<string, IncidentSummary>();
    for (const incident of json.data ?? []) {
      const summary: IncidentSummary = {
        id: incident.id,
        status: incident.attributes.status,
        startedAt: incident.attributes.started_at,
        endedAt: incident.attributes.ended_at ?? null,
      };
      for (const ann of incident.relationships?.announcements?.data ?? []) {
        map.set(String(ann.id), summary); // eslint-disable-line ember/use-ember-get-and-set
      }
    }
    return map;
  } catch {
    return new Map();
  }
}
